import { Outlet, NavLink } from 'react-router-dom';
import { getSession, logout } from '../platform/auth/session';
import { Brand, Icon, type IconName } from '../components/ui/Icon';
import { AREA_PERMISSIONS, usePermissions } from '../platform/auth/permissions';

const navigation: { group: string; items: { to: string; label: string; icon: IconName }[] }[] = [
  {
    group: 'Minha casa',
    items: [
      { to: '/dashboard', label: 'Visão da casa', icon: 'home' },
      { to: '/pessoas', label: 'Pessoas', icon: 'users' },
      { to: '/calendario', label: 'Calendário', icon: 'calendar' },
      { to: '/tarefas', label: 'Tarefas', icon: 'list' },
    ],
  },
  {
    group: 'Recursos',
    items: [
      { to: '/estoque', label: 'Estoque', icon: 'box' },
      { to: '/financeiro', label: 'Financeiro', icon: 'coins' },
      { to: '/obrigacoes', label: 'Obrigações', icon: 'candle' },
      { to: '/documentos', label: 'Documentos', icon: 'folder' },
    ],
  },
  {
    group: 'Organização',
    items: [
      { to: '/cargos', label: 'Cargos e funções', icon: 'tag' },
      { to: '/permissoes', label: 'Permissões', icon: 'shield' },
      { to: '/configuracoes', label: 'Configurações', icon: 'settings' },
      { to: '/assinatura', label: 'Assinatura', icon: 'card' },
    ],
  },
];

function initials(value: string): string {
  return value
    .split(/[\s@._-]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0))
    .join('')
    .toUpperCase();
}

export function Layout() {
  const session = getSession();
  const houseName = session?.houseName ?? 'Casa';
  const { can } = usePermissions();
  const isAdmin = can('roles.read');
  const visibleNavigation = navigation
    .map(({ group, items }) => ({
      group,
      items: items.filter(({ to }) => {
        const permission = AREA_PERMISSIONS[to];
        return permission !== undefined && can(permission);
      }),
    }))
    .filter(({ items }) => items.length > 0);
  return (
    <div className="app-shell">
      <nav className="app-sidebar" aria-label="Áreas da casa">
        <Brand />
        <div className="app-house">
          <span className="icon-box lime">
            <Icon name="home" size={20} />
          </span>
          <div>
            <strong>{houseName}</strong>
            <span>{isAdmin ? 'Administração da casa' : 'Operação da casa'}</span>
          </div>
        </div>
        <ul className="app-nav">
          {visibleNavigation.map(({ group, items }) => (
            <li key={group}>
              <div className="app-nav-group">{group}</div>
              <ul className="app-nav">
                {items.map(({ to, label, icon }) => (
                  <li key={to}>
                    <NavLink to={to} className={({ isActive }) => (isActive ? 'active' : '')}>
                      <Icon name={icon} />
                      {label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
        <div className="app-sidebar-bottom">
          {session && (
            <div className="app-user">
              <span className="avatar">{initials(session.email)}</span>
              <div>
                <strong>{session.email}</strong>
                <span>{houseName}</span>
              </div>
            </div>
          )}
          <button type="button" className="text-button" onClick={logout}>
            <Icon name="logout" size={15} />
            Sair
          </button>
          <small style={{ display: 'block', marginTop: '0.9rem' }}>
            A casa decide. O Zeladoria organiza.
          </small>
        </div>
      </nav>
      <main className="app-main">
        <Outlet />
      </main>
    </div>
  );
}
